import Popover from 'trunks/vue/admin/components/libs/popover.js';
import SearchList from 'trunks/vue/admin/components/search/search_list.js';
import DebounceInput from 'trunks/vue/admin/components/libs/debounce_input.js';
import HierarchicalMenu from 'trunks/vue/admin/components/libs/hierarchical_menu.js';

export const DataclipNavigation = Vue.extend({
  components: {
    popover: Popover,
    'hierarchical-menu': HierarchicalMenu,
    'debounce-input': DebounceInput,
    'search-list': SearchList,
  },

  props: {
    resources: {
      type: String,
      required: true,
    },
    initActivedNodeId: {
      type: Number,
      required: false,
    },
    activeCallback: {
      type: Function,
    },
    preservedNode: {
      type: Object,
    },
    initialTitle: {
      type: String,
      default: '主表单',
    },
  },

  data() {
    return {
      searchedNodes: [],
      keyword: '',
      searching: false,
      activedNode: null,
      activedNodeId: this.initActivedNodeId,
      queryUrl: `${this.resources}/query`,
    };
  },

  template: `
    <popover position='bottom left'
             :caret='false'
             :stopPropagation='true'
             customClass='dataclips-navigation-popover'
             dynamicId='js_dataclips_navigator'
             :turbolinksPermanent='true'
             type='select'
             ref='popoverRef'>
      <div slot='trigger' class='btn text-btn btn-small dataclips-navigator-btn'>
        <span>{{ activedNode && activedNode.title || initialTitle }}</span>
        <i class='slp-caret-down gray-text'></i>
      </div>
      <div slot='content' class='popover-select-content'>
        <div class='popover-select-header'>
          <debounce-input
            placeholder='搜索视图'
            typeClasses='bordered'
            @change='inputChangedFunc'
            ref='searchInputRef' />
        </div>
        <div class='popover-select-body'>
          <search-list
            v-show='searching'
            :items='searchedNodes'
            :toggleFunc='toggleItemFunc'>
            <template slot='option-template' slot-scope='{ item }'>
              <div class='content'>
                <div class='justify-box'>
                  <div class='content'>{{ item.title }}</div>
                  <span class='helper-text dataclip-title-decoration' v-if='item.receipts_count'>{{ item.completed_receipts_count }}/{{ item.receipts_count }}</span>
                  <i :class="activedClassObj(item)" class='gray-text'></i>
                </div>
                <div class='dataclip-title-names text-ellipsis vertical-middle'>
                  <template v-for='ancestor_title in item.ancestor_titles'>
                    <span>{{ ancestor_title }}</span>
                    <i class='slp-chevron-right'></i>
                  </template>
                </div>
              </div>
            </template>
          </search-list>
          <hierarchical-menu
            v-show='!searching'
            :resources='resources'
            :initActivedNodeId='activedNodeId'
            :preservedNodes='_.compact([preservedNode])'
            @valueChanged='activedNodeChangedFunc'
            ref='dataclipsMenu'>
            <template slot='node-decoration' slot-scope='{ node }'>
              <span class='helper-text node-decoration' v-if='node.receipts_count'>{{ node.completed_receipts_count }}/{{ node.receipts_count }}</span>
            </template>
          </hierarchical-menu>
        </div>
      </div>
    </popover>
  `,

  watch: {
    activedNodeId() {
      if (this.activeCallback) this.activeCallback(this);
      this.$refs.searchInputRef.clear();
      this.$refs.popoverRef.close();
    },
  },

  methods: {
    setActivedNode(node) {
      this.activedNode = node;
      this.activedNodeId = node.id;
    },

    activedNodeChangedFunc(node) {
      this.setActivedNode(node);
    },

    inputChangedFunc(value) {
      this.keyword = value;

      if (_.isBlank(this.keyword)) {
        this.searchedNodes = [];
        this.searching = false;
      } else {
        this._searchNodes();
      }
    },

    toggleItemFunc(item) {
      this.setActivedNode(item);
    },

    addNode(node) {
      return this.$refs.dataclipsMenu?.addNode(node);
    },

    activedClassObj(item) {
      return {
        'slp-check': item.id === this.activedNodeId,
        'slp-empty': item.id !== this.activedNodeId,
      };
    },

    _searchNodes() {
      if (this.queryXHR) this.queryXHR.abort();

      this.queryXHR = Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.generateUrlWithParams(this.queryUrl, {
        name: this.keyword,
      }), {
        success: (data) => {
          this.searchedNodes = _.each(data, (item) => {
            item._actived = item.id === this.activedNodeId;
          });
          this.searching = true;
        },
        complete: () => {
          this.queryXHR = null;
        },
      });
    },
  },
});

export const NewDataclipsNavigation = (dataclip, dataclipable, options) => {
  const dataclipableGid = new Skylark.Libs.GlobalID(dataclipable.gid);
  let preservedNode;
  let initialTitle;
  let initActivedNodeId;

  if (options.responseableManaged) {
    preservedNode = {
      id: 0,
      title: '主表单',
      ancestry: null,
      ancestor_titles: [],
      children_count: 0,
      completed_receipts_count: dataclipable.completed_receipts_count,
      receipts_count: dataclipable.receipts_count,
    };
  }

  if (dataclip) {
    initialTitle = dataclip.title;
    initActivedNodeId = dataclip.id;
  } else if (preservedNode) {
    initialTitle = preservedNode.title;
    initActivedNodeId = 0;
  }

  return new DataclipNavigation({
    el: '#js_dataclips_navigator',
    propsData: {
      resources: `/admin${dataclipableGid.toPath()}/dataclips`,
      preservedNode,
      initActivedNodeId,
      initialTitle,
      activeCallback() {
        const actionUrl = _.last(window.location.pathname.split(/\d/));

        if (this.activedNodeId === 0) {
          Turbolinks.visit(`/admin${dataclipableGid.toPath()}${actionUrl}`);
        } else {
          window.open(`/admin/dataclips/${this.activedNodeId}${actionUrl}`);
        }
      },
    },
  });
};
